import { z } from 'zod';

/**
 * Odometer reading validation schema
 * - Must be a non-negative integer
 * - Can be 0
 */
const odometerReadingSchema = z
    .number()
    .nonnegative('Odometer reading must be a non-negative number')
    .int('Odometer reading must be a whole number');
/**
 * Assign Odometer Reading form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(assignOdometerReadingFormSchema)
 */
const assignOdometerReadingFormSchema = z.object({
    odometerReading: odometerReadingSchema,
});

export { assignOdometerReadingFormSchema, odometerReadingSchema };
//# sourceMappingURL=odometerValidation.js.map
